<div class="modal-body modal-scss">
  <div class="row mb-3">
    <div class="col-12 mb-4">
      <div class="d-flex align-items-center justify-content-center">
        <super-button styleClass="blue mt-4" [text]="buttonsToExpand | translate" [icon]="buttonsToExpand === 'openAll' ? 'bi bi-arrows-expand' : 'bi bi-arrows-collapse'" (click)="collapseOrExpandAll()"></super-button>
      </div>
    </div>
    <div class="liste" *ngIf="!loading">
      <p-tree
        [scrollHeight]="'30vh'"
        [value]="classements"
        appendTo="body"
        selectionMode="single"
        [(selection)]="selectedNode"
        (onNodeSelect)="onClassementSelect($event)"
        [emptyMessage]="'noResultFound' | translate"
        styleClass="w-100 pTreeServicesModal"
        [filter]="true">
      </p-tree>
    </div>
    <div class="loading" *ngIf="loading">
      <i class="bi bi-arrow-clockwise"></i>
    </div>
  </div>
  <div class="buttonValidate">
    <super-button
      [text]="'Valider'"
      styleClass="bottomButton green"
      tooltipPosition="bottom"
      tooltipZIndex="99999999"
      [pTooltip]="'Valider le classement'"
      (click)="onSubmit()">
    </super-button>
  </div>
</div>